import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home-page-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-down" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBar, null, {
      left: _withCtx(() => [
        (_ctx.ShowAccountsDropdown)
          ? (_openBlock(), _createBlock(_component_BaseButton, {
              key: 0,
              color: _ctx.ButtonColor.PRIMARY,
              pattern: _ctx.ButtonColorPattern.TRANSPARENT,
              class: "dropdown-container account-text",
              onClick: _ctx.dropDown
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.appIcon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.AccountHeader")), 1),
                _hoisted_2
              ]),
              _: 1
            }, 8, ["color", "pattern", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.dropDownActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Settings.Profile)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.MyAccount")), 1)
              ]),
              (_ctx.showDependents)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Dependents.Home)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.Dependents")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Settings.Security)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.Security")), 1)
              ]),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Settings.Privacy)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.Privacy")), 1)
              ]),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Settings.AccountIdCode)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$mhat("HomePageHeaderBar.VerificationCode")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      right: _withCtx(() => [
        (_ctx.showBackToAppButton)
          ? (_openBlock(), _createBlock(_component_ActionButton, {
              key: 0,
              opts: _ctx.backToAppOptions
            }, null, 8, ["opts"]))
          : (_openBlock(), _createBlock(_component_ActionButton, {
              key: 1,
              opts: _ctx.logOutOptions
            }, null, 8, ["opts"]))
      ]),
      _: 1
    })
  ]))
}